import Card from "../../../models/common/Card";
import iconOne from "../../../assets/img/partnerPortal/homepage/vector_1.png";
import iconTwo from "../../../assets/img/partnerPortal/homepage/vector_2.png";
import iconThird from "../../../assets/img/partnerPortal/homepage/vector_3.png";
import News from "../../../models/common/News";
import custom from "../../../assets/img/partnerPortal/welcomePage/innovate.png";
import gartner_banner from "../../../assets/img/partnerPortal/welcomePage/gartner_banner.png";
import perform_banner from "../../../assets/img/partnerPortal/welcomePage/perform_banner.jpg";
import Banner from "../../../models/common/Banner";

// BANNER
export const TITLE = (
  <div>
    Welcome to your<br></br>Partner Portal
  </div>
);
export const BUTTON_NAME = "Register a deal";
export const BUTTON_LINK = "https://partners.dynatrace.com/#/page/sales";
export const BUTTON_LINK_TIER_2 =
  "https://partners.dynatrace.com/#/deals/new?dealTypeId=8a9982128a9fde9d018ab7600bb300b1";
// --

// BANNERS
const banner0: Banner = new Banner(
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_med[…]race&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  "_parent",
  "100%",
  gartner_banner
);
const banner1: Banner = new Banner(
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  "_parent",
  "100%",
  perform_banner
);
const banner2: Banner = new Banner(
  "https://www.dynatrace.com/innovate/?utm_medium=partner&utm_source=dynatrace&utm_campaign=innovate&utm_content=partner-portal&utm_term=25",
  "_parent",
  "100%",
  custom
);
export const ALL_BANNERS: Array<Banner> = new Array<Banner>(banner0, banner1);

// NEWS AND EVENTS
const news33: News = new News(
  "Perform and Innovate Sponsor Prospectus FY26",
  "https://partners.dynatrace.com/content/8a99822b95b0e7e80195b4734ee018f8",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news32: News = new News(
  "Watch Perform on-demand​",
  "https://www.dynatrace.com/perform/",
  true,
  true,
  true,
  undefined,
  "Watch now"
);
const news31: News = new News(
  "Dynatrace Introduces Observability for Developers​",
  "https://www.dynatrace.com/news/press-release/dynatrace-introduces-observability-for-developers/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news30: News = new News(
  "Dynatrace Partners with Visa Cash App Racing Bulls (VCARB) Formula One™ Team​",
  "https://www.dynatrace.com/news/press-release/dynatrace-partners-with-visa-cash-app-racing-bulls-vcarb-formula-one-team-as-official-observability-performance-analytics-technology-partner/",
  true,
  true,
  true,
  undefined,
  "Read more"
);
const news28: News = new News(
  "Streaming event: Dynatrace & the Power of Possible​",
  " https://webinars.techstronglearning.com/dynatrace-and-the-power-of-possible?utm_medium=partner&utm_source=dynatrace&utm_campaign=virtual-event&utm_content=portal&utm_term=q3fy25",
  false,
  true,
  true
);
const news27: News = new News(
  "Partners lead with Dynatrace SaaS​",
  "https://partners.dynatrace.com/#/collateral/8a9983ce90d6f9a50190f221a5f121bd",
  false,
  true,
  true
);
const news26: News = new News(
  "Dynatrace named a Leader in the 2024 Gartner® Magic Quadrant™ for Observability Platforms​",
  "https://www.dynatrace.com/gartner-magic-quadrant-for-observability-platforms/?utm_medium=partner&utm_source=dynatrace&utm_campaign=partner&utm_content=portal&utm_term=q2fy25",
  false,
  true,
  true
);

export const ALL_NEWS_LIST: Array<News> = new Array<News>(
  news33,
  news32,
  news31,
  news30,
  news28,
  news27,
  news26
);

const event9: News = new News(
  "Learn how to master the Dynatrace Partner Deliver Toolkit",
  "https://info.dynatrace.com/noram-all-wb-partner-delivery-toolkit-26404-od-fulfillment.html?utm_medium=partner&utm_source=dynatrace&utm_campaign=portal&utm_content=all-active-partners&utm_term=none&mkt_tok=MzUyLU5WTy01NjIAAAGY5uZvOiRelPaOTN3vSicEXtUu1G4fcCPHd0QPVHj8YbfjrjGTV3GCMjiUFZaQKdEbZlgiU3boBximTOnaZiQb",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);
const event8: News = new News(
  "Recap the 2025 Partner Keynote",
  "https://partners.dynatrace.com/#/page/perform-2025-on-demand",
  true,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);

const event7: News = new News(
  "Creating custom solutions with Omnilogy",
  "https://info.dynatrace.com/global-all-wc-partner-app-developer-journey-with-omnilogy-24634-registration.html?utm_medium=partner&utm_source=dynatrace&utm_campaign=webinar&utm_content=portal&utm_term=q2fy25",
  false,
  true,
  true,
  "On-Demand Webinar",
  "Watch now"
);

const event5: News = new News(
  "Five best practices to improve your cloud native application security posture",
  "https://info.dynatrace.com/global-all-wc-isg-appsec-webinar-24103-registration.html?utm_medium=partner&utm_source=dynatrace&utm_campaign=virtual-event&utm_content=portal&utm_term=q4fy24",
  false,
  true,
  false,
  "On-Demand Webinar",
  "Watch now"
);
// const event3: News = new News(
//   "Perform 2024",
//   "https://www.dynatrace.com/perform/ ",
//   false,
//   false,
//   false,
//   "On-Demand Webinar",
//   "Watch now"
// );
//const event1: News = new News("2024 IT and Observability Forecast", "https://www.dynatrace.com/info/webinars/it-observability-2024/", true, true, true, "On-Demand Webinar", "Watch now");
//const event2: News = new News("Generate new leads and drive sales with Dynatrace", "https://info.dynatrace.com/global-all-dh-supercharging-pipeline-with-tcma-23395-registration.html", false, false, false, "On-Demand Webinar", "Watch now");
//const event4: News = new News("Amplify partner enablement PowerUP", "https://www.dynatrace.com/amplify/ ", false, false, false, "On-Demand Webinar", "Watch now");
export const ALL_EVENTS_LIST: Array<News> = new Array<News>(
  event9,
  event8,
  event7,
  event5
);

// BENEFITS CARDS

const card1: Card = new Card(
  "About our partner portal",
  "Learn more",
  iconOne,
  undefined,
  "https://www.dynatrace.com/resources/partners/about-partner-program.html"
);
const card2: Card = new Card(
  "Why partner with Dynatrace",
  "Learn more",
  iconTwo,
  undefined,
  "https://www.dynatrace.com/resources/partners/why-partner.html"
);
const card3: Card = new Card(
  "Find a Dynatrace Partner",
  "Learn more",
  iconThird,
  undefined,
  "https://www.dynatrace.com/partners/solution-partners/"
);
const cardsFirstRow: Card[] = [card1, card2, card3];

export const ALL_CARD_ROWS: Record<number, Card[]> = {
  [0]: cardsFirstRow,
};
// --

// SIGN UP
export const SIGN_UP_TITLE = "Interested in partnering with us?";
export const SIGN_UP_SUB_TITLE =
  "Just complete a quick application form and we’ll be in touch to get you started.";
export const BANNER_LINK =
  "https://university.dynatrace.com/ondemand/course/35226?content=content&section=35374";
export const BUTTON_NAME_SIGN_UP = "Become a Partner";
// --
